import React from "react"
import Icon from "../../../components/AppIcon"

// Pure presentation over data already loaded by the parent workspace â€”
// no new Firestore reads needed here. Attendance rate is computed per
// schedule event from cohort.attendance (shape: { [eventId]: { [userId]: bool } }).
const CohortAnalyticsTab = ({ cohort, summary }) => {
  const scheduleEvents = cohort?.scheduleEvents || []
  const attendance = cohort?.attendance || {}

  const attendanceByEvent = [...scheduleEvents]
    .sort((a, b) => new Date(a?.date || 0) - new Date(b?.date || 0))
    .map((ev) => {
      const marks = Object.values(attendance?.[ev?.id] || {})
      const total = marks?.length || 0
      const presentCount = marks?.filter((v) => v === true)?.length || 0
      return {
        id: ev?.id,
        title: ev?.title,
        date: ev?.date,
        rate: total ? Math.round((presentCount / total) * 100) : null,
      }
    })

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div className="bg-card border border-border rounded-xl p-4">
          <p className="text-xs text-muted-foreground">Total Learners</p>
          <p className="text-2xl font-bold text-foreground">{summary?.total || 0}</p>
        </div>
        <div className="bg-card border border-border rounded-xl p-4">
          <p className="text-xs text-muted-foreground">Active Rate</p>
          <p className="text-2xl font-bold text-foreground">{summary?.activePercent || 0}%</p>
        </div>
        <div className="bg-card border border-border rounded-xl p-4">
          <p className="text-xs text-muted-foreground">Completion Rate</p>
          <p className="text-2xl font-bold text-foreground">{summary?.completionPercent || 0}%</p>
        </div>
      </div>

      <div className="bg-card border border-border rounded-xl p-4">
        <h3 className="text-sm font-semibold text-foreground mb-4">Attendance by Session</h3>
        {attendanceByEvent?.length === 0 ? (
          <p className="text-sm text-muted-foreground">No schedule events yet.</p>
        ) : (
          <div className="space-y-3">
            {attendanceByEvent?.map((ev) => (
              <div key={ev.id}>
                <div className="flex items-center justify-between mb-1">
                  <span className="text-sm text-foreground">{ev.title}</span>
                  <span className="text-xs text-muted-foreground">
                    {ev.rate === null ? "Not taken" : `${ev.rate}%`}
                  </span>
                </div>
                <div className="h-1.5 rounded-full bg-muted overflow-hidden">
                  <div className="h-full bg-primary rounded-full" style={{ width: `${ev.rate || 0}%` }} />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="bg-card border border-border rounded-xl p-8 text-center">
        <Icon name="Sparkles" size={20} className="text-muted-foreground mx-auto mb-2" />
        <p className="text-sm text-muted-foreground">Deeper analytics (progress distribution, engagement trends) coming as more cohort data accumulates.</p>
      </div>
    </div>
  )
}

export default CohortAnalyticsTab